module.exports = __webpack_public_path__ + "static/img/img-demo.4d70314a.png";